import { type VideoQuality } from '../../webrtc/media';

/**
 * Gets the video quality from the resolution
 * @param resolution - String containing the width of the video in the format '[width]x[height]'
 * @returns The video quality or undefined if the width cannot be parsed or resolution is invalid
 */
export const parseVideoQuality = (
  resolution?: string,
): VideoQuality | undefined => {
  if (!resolution) {
    return undefined;
  }

  const [width] = resolution.split('x').map(Number);
  if (width === undefined || isNaN(width)) {
    return undefined;
  }

  if (width >= 1280) {
    return 'hd';
  }

  if (width >= 640) {
    return 'sd';
  }

  return 'ld';
};
